// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_e0d032fb","item":"_ebed69d","image":"_52225f4f","title":"_8de00268","description":"_4d103d4e","link":"_32326c68"};